import React from "react";
import { Link } from "react-router-dom";
import { CurveMark } from "./CarparkCurve";
import { BRAND } from "../data/content";
import { Linkedin, Mail, Phone } from "lucide-react";
import { NewsletterSignup } from "./FooterExtras";

export default function Footer() {
  return (
    <footer className="bg-[#0B0B0C] border-t border-[#343437] relative grain" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 text-[#FAF9F6]">
              <CurveMark className="w-[64px] h-[36px] text-[#FAF9F6]" />
              <span className="font-display font-extrabold text-lg tracking-[0.2em] uppercase">JJ Argent</span>
            </div>
            <p className="mt-6 font-display text-3xl md:text-4xl leading-[1.1] tracking-tight text-[#FAF9F6] max-w-md">
              Built to run without me.{" "}<br />
              <span className="text-[#A9A9A6]">Designed to create impact that lasts.</span>
            </p>
            <p className="mt-6 font-signature text-2xl text-[#D8A936]">JJ Argent</p>
          </div>

          <div className="lg:col-span-3">
            <p className="eyebrow">Navigate</p>
            <ul className="mt-5 space-y-3 font-display text-[15px]">
              <li><Link to="/" className="hover:text-[#D8A936] transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-[#D8A936] transition-colors">About</Link></li>
              <li><Link to="/case-studies" className="hover:text-[#D8A936] transition-colors">Case Studies</Link></li>
              <li><Link to="/services" className="hover:text-[#D8A936] transition-colors">Services</Link></li>
              <li><Link to="/ai-solutions" className="hover:text-[#D8A936] transition-colors">AI Solutions</Link></li>
              <li><Link to="/for-recruiters" className="hover:text-[#D8A936] transition-colors">For Recruiters</Link></li>
              <li><Link to="/contact" className="hover:text-[#D8A936] transition-colors">Contact</Link></li>
              {/* Speaking / Guestbook / Community unpublished — Batch 2 §10 & §10A.
                  Routes still exist behind the scenes so they can be re-enabled
                  without a rebuild once there's content / activity. */}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="eyebrow">Let's connect</p>
            <ul className="mt-5 space-y-4 text-[15px] text-[#A9A9A6]">
              <li className="text-[#FAF9F6]">{BRAND.location}</li>
              <li>
                <a
                  href={`mailto:${BRAND.email}`}
                  data-testid="footer-email"
                  className="inline-flex items-center gap-2 hover:text-[#D8A936] transition-colors group"
                >
                  <Mail size={16} className="transition-transform group-hover:-translate-y-0.5" /> {BRAND.email}
                </a>
              </li>
              <li>
                <a
                  href={BRAND.phoneHref}
                  data-testid="footer-phone"
                  className="inline-flex items-center gap-2 hover:text-[#D8A936] transition-colors group"
                >
                  <Phone size={16} className="transition-transform group-hover:-translate-y-0.5" /> {BRAND.phone}
                </a>
              </li>
              <li>
                <a
                  href={BRAND.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-linkedin"
                  className="inline-flex items-center gap-2 hover:text-[#D8A936] transition-colors group"
                >
                  <Linkedin size={16} className="transition-transform group-hover:-translate-y-0.5" /> LinkedIn
                </a>
              </li>
            </ul>
            <Link to="/contact" data-testid="footer-cta" className="btn-primary mt-8 hover:-translate-y-0.5">
              Book a call
            </Link>
            <div className="mt-8">
              <p className="eyebrow">Notes from JJ</p>
              <p className="mt-2 text-xs text-[#A9A9A6] leading-relaxed max-w-xs">
                Occasional field notes — case studies, playbooks, hiring. No spam.
              </p>
              <NewsletterSignup />
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#343437] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[#A9A9A6] tracking-widest uppercase">
          <p>© {new Date().getFullYear()} JJ Argent. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-6">
            <Link to="/privacy" data-testid="footer-privacy" className="hover:text-[#D8A936] transition-colors">
              Privacy
            </Link>
            <p className="font-display">Systems · Programs · Impact</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
